// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"b19e806e","513":"33e20563","703":"249d8a79","787":"be5eb0dc"}[chunkId] + ".chunk.js";
};